import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import MdAttachFile from 'react-icons/lib/md/attach-file';
import MdClose from 'react-icons/lib/md/close';
import CircularLoader from '../../../../components/circularLoader/CircularLoader';
import FileAttach from '../../../../components/FileAttach';
import LessonFilePreviewDialog from '../../../common/lessonInfoDialog/LessonFilePreviewDialog';
import StudioReadOnlyMessage from "../StudioReadOnlyMessage";

@inject('projectStore', 'looperStore', 'dialogStore')
@observer
class StudioNotes extends Component {
    componentWillUnmount() {
        this.props.dialogStore.closeFilePreviewDialog();
    }

    handleRemove = name => (e) => {
        e.stopPropagation();
        this.props.projectStore.onFileDelete(name);
    };

    render() {
        const {previewMode, projectStore, looperStore, dialogStore, isReadOnly} = this.props;
        return (
            <div className="m-studio-notes">
                <div className="m-studio-heading"><FormattedMessage id="studio.notes.heading"/></div>
                <div className="m-studio-content">
                    {isReadOnly && <StudioReadOnlyMessage/>}
                    {!previewMode && !isReadOnly && <FileAttach
                        className="m-studio-attachments"
                        onChange={projectStore.onFileChange}>
                        <button className="m-studio-btn">
                            <div className="icon"><MdAttachFile style={{transform: 'rotate(45deg)'}}/></div>
                            <div className="name"><FormattedMessage id="createLesson.attachmentPlaceholder"/></div>
                        </button>
                    </FileAttach>}
                    {(!looperStore.isLooperLoaded || projectStore.isFileLoading) && <CircularLoader/>}
                    {projectStore.attachmentFiles.map((file, index) => (
                        <div
                            key={`${file.name}${index}`}
                            onClick={projectStore.openFilePreview(file)}
                            className="m-studio-attach-file">
                            <div className="icon"><MdAttachFile/></div>
                            <div className="name">{file.name}</div>
                            {!isReadOnly && <div className="remove" onClick={this.handleRemove(file.name)}><MdClose/></div>}
                        </div>
                    ))}
                </div>
                {dialogStore.showFilePreviewDialog && <LessonFilePreviewDialog
                    open={dialogStore.showFilePreviewDialog}
                    onClose={dialogStore.closeFilePreviewDialog}
                    file={projectStore.openedFile}
                    video={projectStore.openedVideo}
                />}
            </div>
        );
    }
}

export default StudioNotes;
